/* Sepet +1 teklifi (Horizon): Ekle butonu ve sepet kuralları (en fazla 1 teklif ürünü, normal ürün yoksa teklif çıkar). */
(() => {
  let busy = false;

  async function updateLines(lines) {
    const actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) return actions.updateCart({ lines });
    for (const l of lines) {
      const body = l.id ? { id: l.id, quantity: l.quantity } : { id: Number(l.merchandiseId), quantity: l.quantity };
      await fetch(l.id ? '/cart/change.js' : '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    }
    window.location.reload();
  }

  function parse(str) {
    return (str || '').split(',').filter(Boolean).map((s) => {
      const i = s.lastIndexOf(':');
      return { key: s.slice(0, i), qty: Number(s.slice(i + 1)) };
    });
  }

  async function enforce() {
    if (busy) return;
    const el = document.querySelector('[data-cart-offer-state]');
    if (!el) return;
    const regular = Number(el.dataset.regularCount || 0);
    const lines = parse(el.dataset.offerLines);
    let fix = null;
    if (lines.length && regular === 0) fix = lines.map((l) => ({ id: l.key, quantity: 0 }));
    else if (lines.length > 1) fix = lines.slice(1).map((l) => ({ id: l.key, quantity: 0 }));
    else if (lines.length === 1 && lines[0].qty > 1) fix = [{ id: lines[0].key, quantity: 1 }];
    if (!fix) return;
    busy = true;
    try { await updateLines(fix); } catch (e) { console.warn('[cart-offer]', e); } finally { busy = false; }
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-offer-add]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    btn.setAttribute('aria-disabled', 'true');
    try { await updateLines([{ merchandiseId: btn.dataset.variantId, quantity: 1 }]); }
    catch (e) { console.warn('[cart-offer]', e); btn.removeAttribute('aria-disabled'); }
  });

  let t = null;
  const schedule = () => { clearTimeout(t); t = setTimeout(enforce, 250); };
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['data-offer-lines', 'data-regular-count']
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
